import _ from 'lodash';

export default function SecurityGroupsListController(
  $scope,
  $filter,
  $state,
  $stateParams,
  securityGroupsService,
  gettextCatalog,
) {
  'ngInject';

  //Local Variables
  $scope.searchText = '';
  $scope.previousSearchText = '';
  $scope.unavailable = gettextCatalog.getString('Unavailable');
  $scope.securityGroups = [];
  $scope.filteredSecurityGroups = [];
  $scope.createSuccessFlag = false;
  $scope.deleteSuccessFlag = false;
  $scope.selfRemovedSuccessFlag = false;

  if ($stateParams) {
    if ($stateParams.create) {
      $scope.createSuccessFlag = true;
    }
    if ($stateParams.deleted) {
      $scope.deleteSuccessFlag = true;
    }
    if ($stateParams.selfRemoved) {
      $scope.selfRemovedFlag = true;
    }
  }

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');

  //Sort filteredSecurityGroups
  $scope.orderSecurityGroups = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
    GTM_GroupChanged('securityOrderChanged');
  };

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 20;
  $scope.maxSize = 3;

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.previousSearchText === $scope.searchText) return;
    $scope.filteredSecurityGroups = $filter('filter')($scope.securityGroups, $scope.searchText);
    $scope.previousSearchText = $scope.searchText;
    GTM_GroupChanged('securityFiltered');
  };

  //Capture errors and display a message to the user below the form if errors exist
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.loading = true;

  //reset flags after user selects a new row
  $scope.resetFlags = function () {
    $scope.createSuccessFlag = false;
    $scope.deleteSuccessFlag = false;
    $scope.selfRemovedSuccessFlag = false;
  };

  $scope.pageChanged = function () {
    GTM_GroupChanged('securityPageChanged');
  };

  //Get all Security Groups
  securityGroupsService.getAllSecurityGroups().then(function (response) {
    $scope.securityGroups = response.data.data;

    //add concatnat tags for sorting
    if ($scope.securityGroups) {
      _.each($scope.securityGroups, function (sg) {
        sg.tags.sort(function (a, b) {
          var x = a.toLowerCase();
          var y = b.toLowerCase();
          if (x < y) {
            return -1;
          }
          if (x > y) {
            return 1;
          }
          return 0;
        });
        var concatData = _.map(sg.tags, function (tag) {
          return tag.toLowerCase();
        });
        sg['concattags'] = concatData.join();
      });
    }

    $scope.filteredSecurityGroups = $scope.securityGroups.slice();
    $scope.$broadcast('groupListLoaded');
    $scope.loading = false;
    GTM_GroupChanged('securityLoaded');
  }, handleError);

  //General Error Handler
  function handleError(error) {
    $scope.loading = false;

    var errorMsg = gettextCatalog.getString('An error occurred while retrieving security groups');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }
    $scope.onLoadErrorText = errorMsg;
    $scope.onLoadErrorFlag = true;
  }

  function GTM_GroupChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.securityGroups.length,
        totalFiltered: $scope.filteredSecurityGroups.length,
        pageNumber: $scope.currentPage,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
      },
    });
  }
}
